"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtistTopSectionContainer = ArtistTopSectionContainer;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
function ArtistTopSectionContainer(_a) {
    var title = _a.title, showAllHref = _a.showAllHref, showAllLabel = _a.showAllLabel, showAllLabelSx = _a.showAllLabelSx, onShowAllClick = _a.onShowAllClick, children = _a.children;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: "".concat(tokens_1.spacing.md, "px"),
            alignSelf: 'stretch',
        }, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", spacing: "".concat(tokens_1.spacing.sm, "px"), sx: { minHeight: tokens_1.lineHeight.lg }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: __assign(__assign({ flexGrow: 1 }, tokens_1.textStyles.sectionTitle), { color: p.foreground.neutral.primary }), children: title }), showAllHref && showAllLabel && (
                    // component="a" を直接書くと theme の LinkComponent (utoniq-app では
                    // react-router) に差し替わらず全画面リロードになる。MuiLink は
                    // defaultProps.component で差し替え済みなので Link を使う。
                    (0, jsx_runtime_1.jsx)(material_1.Link, { href: showAllHref, onClick: onShowAllClick, sx: __assign(__assign(__assign({}, tokens_1.textStyles.label), { color: p.foreground.primary.main, textDecoration: 'none', flexShrink: 0, whiteSpace: 'nowrap' }), showAllLabelSx), children: showAllLabel }))] }), (0, jsx_runtime_1.jsx)(material_1.Box, { children: children })] }));
}
